import { Outlet } from "react-router-dom";

function ShipmentTrackingMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default ShipmentTrackingMain;